// The main buying paths stay in a deliberate order across the header and
// footer. CMS pages are included only while they are published and indexable.
// Native routes (pricing, blog, and industry pages) are listed separately.
const PRODUCT = [
  { label: 'Commerce', href: '/product/commerce' },
  { label: 'Configure & Quote', href: '/product/build' },
  { label: 'Production', href: '/product/production' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'AI for Woodshops', href: '/product/ai' },
];

const ADD_ONS = [
  { label: 'Dealer Portal', href: '/add-ons/dealer-portal' },
  { label: 'Build Sheets & CAM', href: '/add-ons/build-sheets-cam' },
  { label: 'Shop Floor', href: '/add-ons/shop-floor' },
  { label: 'Inventory', href: '/add-ons/inventory' },
  { label: 'Website Builder', href: '/add-ons/website' },
];

const INDUSTRIES = [
  { label: 'Cabinet Makers', href: '/solutions/cabinet-makers' },
  { label: 'Cabinet Doors & Components', href: '/solutions/door-manufacturers' },
  { label: 'Production Cabinets', href: '/solutions/production-cabinet-manufacturers' },
  { label: 'Millwork & Trim', href: '/solutions/millwork-and-trim' },
  { label: 'Custom Furniture', href: '/solutions/custom-furniture' },
];

const NATIVE_HREFS = new Set([
  '/pricing', '/blog', '/changelog', '/how-automated-is-your-shop', '/quote-builder', ...INDUSTRIES.map((item) => item.href),
]);

function liveItems(navData, items) {
  const published = new Set((navData?.allPages || []).map((page) => page.href));
  return items.filter((item) => NATIVE_HREFS.has(item.href) || published.has(item.href));
}

export function productNavColumns(navData) {
  if (!Array.isArray(navData?.allPages)) return null;
  return [
    { title: 'Platform', items: liveItems(navData, PRODUCT) },
    { title: 'Add-ons', items: liveItems(navData, ADD_ONS) },
  ].filter((column) => column.items.length);
}

export function marketingFooterColumns(navData) {
  if (!Array.isArray(navData?.allPages)) return null;
  return [
    {
      title: 'Product',
      items: liveItems(navData, [
        { label: 'Product Overview', href: '/product' },
        ...PRODUCT.slice(0, 4),
        { label: 'Pricing', href: '/pricing' },
      ]),
    },
    { title: 'Add-ons', items: liveItems(navData, ADD_ONS) },
    { title: 'Industries', items: INDUSTRIES },
    {
      title: 'Resources',
      items: liveItems(navData, [
        { label: 'How Automated Is Your Shop?', href: '/how-automated-is-your-shop' },
        { label: 'Quote Builder', href: '/quote-builder' },
        { label: 'Demo Library', href: '/resources/demo-library' },
        { label: 'Blog', href: '/blog' },
        { label: 'Help Center', href: '/help' },
        { label: 'Compare', href: '/compare' },
        { label: 'Customers', href: '/customers' },
      ]),
    },
    {
      title: 'Company',
      items: liveItems(navData, [
        { label: 'About', href: '/about' },
        { label: 'Contact', href: '/contact' },
        { label: 'Careers', href: '/careers' },
        { label: 'Press', href: '/press' },
        { label: 'Trust', href: '/trust' },
      ]),
    },
  ].filter((column) => column.items.length);
}
